document.addEventListener('DOMContentLoaded', () => {
	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	const modules = document.querySelectorAll('.accordion-module');

	const clearTransitionHandler = (body) => {
		if (body._accordionTransitionEnd) {
			body.removeEventListener('transitionend', body._accordionTransitionEnd);
			body._accordionTransitionEnd = null;
		}
	};

	const setExpandedState = (item, summary, expanded) => {
		if (expanded) {
			item.classList.add('is-open');
		} else {
			item.classList.remove('is-open');
		}
		summary.setAttribute('aria-expanded', expanded ? 'true' : 'false');
	};

	const measureExpandedHeight = (body) => {
		const previousHeight = body.style.height;
		body.style.height = 'auto';
		const expandedHeight = body.scrollHeight;
		body.style.height = previousHeight;
		return expandedHeight;
	};

	const openItem = (item, body, summary) => {
		clearTransitionHandler(body);
		item.setAttribute('open', '');
		setExpandedState(item, summary, true);

		if (prefersReducedMotion) {
			body.style.height = 'auto';
			return;
		}

		const startHeight = body.getBoundingClientRect().height;
		const targetHeight = measureExpandedHeight(body);

		body.style.height = `${startHeight}px`;
		body.offsetHeight;

		requestAnimationFrame(() => {
			body.style.height = `${targetHeight}px`;
		});

		const onTransitionEnd = (event) => {
			if (event.propertyName !== 'height') {
				return;
			}
			body.style.height = 'auto';
			clearTransitionHandler(body);
			body.removeEventListener('transitionend', onTransitionEnd);
		};
		body._accordionTransitionEnd = onTransitionEnd;
		body.addEventListener('transitionend', onTransitionEnd);
	};

	const closeItem = (item, body, summary) => {
		clearTransitionHandler(body);
		setExpandedState(item, summary, false);

		if (prefersReducedMotion) {
			body.style.height = '0px';
			item.removeAttribute('open');
			return;
		}

		const startHeight = body.getBoundingClientRect().height;
		body.style.height = `${startHeight}px`;
		body.offsetHeight;

		requestAnimationFrame(() => {
			body.style.height = '0px';
		});

		const onTransitionEnd = (event) => {
			if (event.propertyName !== 'height') {
				return;
			}
			item.removeAttribute('open');
			clearTransitionHandler(body);
			body.removeEventListener('transitionend', onTransitionEnd);
		};
		body._accordionTransitionEnd = onTransitionEnd;
		body.addEventListener('transitionend', onTransitionEnd);
	};

	modules.forEach((module) => {
		const items = Array.from(module.querySelectorAll('.accordion-module__item'));

		items.forEach((item) => {
			const body = item.querySelector('.accordion-module__item-body');
			const summary = item.querySelector('.accordion-module__item-title');

			if (!body || !summary) {
				return;
			}

			body.style.overflow = 'hidden';
			body.style.transition = prefersReducedMotion ? 'none' : 'height 0.45s cubic-bezier(0.22, 0.61, 0.36, 1)';
			body.style.height = item.hasAttribute('open') ? 'auto' : '0px';
			setExpandedState(item, summary, item.hasAttribute('open'));

			summary.addEventListener('click', (event) => {
				event.preventDefault();
				const isOpen = item.hasAttribute('open');

				if (isOpen) {
					closeItem(item, body, summary);
					return;
				}

				items.forEach((otherItem) => {
					if (otherItem === item || !otherItem.hasAttribute('open')) {
						return;
					}
					const otherBody = otherItem.querySelector('.accordion-module__item-body');
					const otherSummary = otherItem.querySelector('.accordion-module__item-title');
					if (otherBody) {
						closeItem(otherItem, otherBody, otherSummary || summary);
					}
				});

				openItem(item, body, summary);
			});
		});
	});
});
